/* Meat N' Bone - BYOB Section: "Product Weight" metafield to the right of the
 * price in every product tile.
 *
 * Weights come from the theme in bulk: /collections/all?view=amplify-weights
 * (templates/collection.amplify-weights.liquid) returns a {productId: weight}
 * map, 250 products per page - the whole catalog is 2 requests, so no
 * per-product request storm and no storefront 429 throttling.
 *
 * The fetch starts immediately at script load, gated on the app block's
 * server-rendered container [data-amplify="byob-inline-widget"] (present in the
 * initial HTML ~4s before the widget boots), so by the time amplifyWidget:loaded
 * fires - with the widget root and cards already in the DOM - the map is ready
 * and the weights show instantly. The amplifyWidget:updateData listener only
 * restores wiped weights after re-renders (throttled: the hidden builder on
 * this page broadcasts continuously, a debounce would starve).
 *
 * Install: theme assets + in theme.liquid:
 *   <script src="{{ 'amplify-byob-card-weight.js' | asset_url }}" defer></script>
 */
(() => {
  'use strict';

  if (!document.querySelector('[data-amplify="byob-inline-widget"]')) return;

  let weights = null;
  let throttled = false;

  const style = document.createElement('style');
  style.textContent = `
    .amplify-product-weight {
      margin-left: auto;
      align-self: flex-end;
      color: var(--ps-theme-color, #121212);
      opacity: .55;
      font-size: 14px;
      line-height: 1;
    }
  `;
  document.head.appendChild(style);

  const decorate = () => {
    if (!weights) return;
    for (const card of document.querySelectorAll('.picky-byob-inline .picky-product-card[data-product-id]')) {
      if (card.querySelector('.amplify-product-weight')) continue;
      const text = weights[card.dataset.productId];
      const prices = card.querySelector('.picky-product-card__prices-wrapper');
      if (!text || !prices) continue;
      const el = document.createElement('div');
      el.className = 'amplify-product-weight';
      el.textContent = text;
      prices.insertAdjacentElement('beforeend', el);
    }
  };

  const loadPage = (page) => fetch(`/collections/all?view=amplify-weights&page=${page}`).then((res) => res.json());

  loadPage(1).then(async ({ pages, weights: first }) => {
    const rest = await Promise.all(Array.from({ length: pages - 1 }, (unused, i) => loadPage(i + 2)));
    weights = Object.assign(first, ...rest.map((page) => page.weights));
    decorate();
  }).catch(() => {});

  window.addEventListener('amplifyWidget:loaded', decorate);

  window.addEventListener('amplifyWidget:updateData', () => {
    if (throttled) return;
    throttled = true;
    setTimeout(() => {
      throttled = false;
      decorate();
    }, 200);
  });
})();
